import React from 'react';
import { RouteProps, Outlet, Navigate } from 'react-router-dom';

import { ErrorRoutes, RoleUser } from '@homesusa/core';
import { useAuth } from '../providers';
import { Loading } from './loading.component';
import { PrivateRouteUserRole } from './private-route-user-role.component';

export type PrivateRouteProps = RouteProps & {
  allowedUserRoles?: RoleUser[];
  forbidden?: boolean;
};

export const PrivateRoute = ({
  allowedUserRoles,
  forbidden,
  component = <Outlet />
}: PrivateRouteProps & { component?: React.ReactNode }): JSX.Element => {
  const auth = useAuth();

  const checkUser = async () => {
    if (!auth.user) {
      try {
        // Try to silently renew the token before redirecting
        await auth.signinSilent();
      } catch (error) {
        console.log('Silent sign-in failed, redirecting to login', error);
        // Only redirect if silent renewal fails
        await auth.signinRedirect();
        return;
      }
    }
  };

  React.useLayoutEffect(() => {
    checkUser();
  }, [auth.user]);

  if (!!forbidden) {
    return <Navigate to={ErrorRoutes.ForbiddenError} />;
  }
  if (!auth.user) {
    return <Loading />;
  }

  return (
    <PrivateRouteUserRole allowedUserRoles={allowedUserRoles}>{component}</PrivateRouteUserRole>
  );
};
